import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {PrimerComponentStatisticSchema} from './primerComponentStatistic'

export const PrimerStatisticsSchema = buildEntrySchemaFor('primerStatistics', {
  fields: z.lazy(() =>
    z.object({
      statistics: z.array(PrimerComponentStatisticSchema),
    }),
  ),
})

export type PrimerStatistics = z.infer<typeof PrimerStatisticsSchema>
